import StatusbarConstants from '../constants/statusbar_constants';
import {Filters} from '../constants/filter/filters';

function filtersToStatusbarStatus(filters, postcodeExistsButNeedsToBeLoaded) {
    if (!filters[Filters.WIDTH] && !filters[Filters.HEIGHT] && !filters[Filters.DIAMETER]) {
        return StatusbarConstants.ALL_MISSING;
    }

    if (!filters[Filters.WIDTH] || !filters[Filters.HEIGHT] || !filters[Filters.DIAMETER]) {
        return StatusbarConstants.DIMENSIONS_MISSING;
    }

    if (!filters[Filters.SPEED_INDEX] && !filters[Filters.LOAD_INDEX] && !filters[Filters.POSTCODE]) {
        return StatusbarConstants.TYRE_INDEX_AND_POSTCODE_MISSING;
    }

    if (!filters[Filters.SPEED_INDEX] && filters[Filters.LOAD_INDEX]) {
        return StatusbarConstants.SPEED_INDEX_MISSING;
    }

    if (filters[Filters.SPEED_INDEX] && !filters[Filters.LOAD_INDEX]) {
        return StatusbarConstants.LOAD_INDEX_MISSING;
    }

    if (!filters[Filters.SPEED_INDEX] && !filters[Filters.LOAD_INDEX]) {
        return StatusbarConstants.TYRE_INDEX_MISSING;
    }

    const hasPostcode = filters[Filters.POSTCODE] || postcodeExistsButNeedsToBeLoaded;

    if (!hasPostcode) {
        return StatusbarConstants.POSTCODE_MISSING;
    }

    if (filters[Filters.WIDTH] && filters[Filters.HEIGHT] && filters[Filters.DIAMETER] && filters[Filters.SPEED_INDEX] && filters[Filters.LOAD_INDEX] && hasPostcode) {
        return StatusbarConstants.NONE_MISSING;
    }
}

export {filtersToStatusbarStatus};
